import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../shared/controls/abstract.bidit.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent extends AbstractBiditComponent implements OnInit {

  constructor(private deviceDetectorService: DeviceDetectorService, private router: Router, private activatedRoute: ActivatedRoute) {
    super(deviceDetectorService);
  }

  ngOnInit() {
  };
}
